<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close" @click.prevent="closeModal()"><span aria-hidden="true">&times;</span>
        </button>
      </h5>
    </div>
    <div class="container-fluid">
      <div v-if="generalErrorMessage" class="row">
        <div class="col">
          <div class="alert alert-danger" role="alert">
            {{ generalErrorMessage }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8">
          <b-form-group :label-cols="5" label="Code" :state="stateForField('code')" :invalid-feedback="errorForField('code')" label-class="text-right">
            <b-form-input v-model="allowableFeeScheduleCode.code"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Modifier" :state="stateForField('modifier')" :invalid-feedback="errorForField('modifier')" label-class="text-right">
            <b-form-input v-model="allowableFeeScheduleCode.modifier"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Discount Eligible" :state="stateForField('discountEligible')" :invalid-feedback="errorForField('discountEligible')" label-class="text-right">
            <b-form-radio-group v-model="allowableFeeScheduleCode.discountEligible" class="pt-2" :options="yesNoOptions"/>
          </b-form-group>
          <b-form-group :label-cols="5" label="Facility Fee" :state="stateForField('facilityFee')" :invalid-feedback="errorForField('facilityFee')" label-class="text-right">
            <b-input-group prepend="$"><b-form-input v-model="allowableFeeScheduleCode.facilityFee"></b-form-input></b-input-group>
          </b-form-group>
          <b-form-group :label-cols="5" label="Non Facility Fee" :state="stateForField('nonFacilityFee')" :invalid-feedback="errorForField('nonFacilityFee')" label-class="text-right">
            <b-input-group prepend="$"><b-form-input v-model="allowableFeeScheduleCode.nonFacilityFee"></b-form-input></b-input-group>
          </b-form-group>
          <b-form-group :label-cols="5" label="Medicare Multiplier" :state="stateForField('medicareMultiplier')" :invalid-feedback="errorForField('medicareMultiplier')" label-class="text-right">
            <b-input-group append="%"><b-form-input v-model="allowableFeeScheduleCode.medicareMultiplier"></b-form-input></b-input-group>
          </b-form-group>
        </div>
        <div class="col-2 col-offset"></div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="saveFeeScheduleCode()">
        <i v-if="isSaving" class="fa fa-spinner fa-spin"></i> Save
      </button>
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="closeModal()">Close
      </button>
    </div>
  </b-modal>
</template>

<script>
  import api from '../services/api'
  import _ from 'lodash'
  import ErrorsMixin from '@/mixins/ErrorsMixin'

  export default {
    name: 'AllowableFeeScheduleCodesModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      allowableFeeScheduleId: {
        type: Number,
        required: true
      },

      editAllowableFeeScheduleCode: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        allowableFeeScheduleCode: {},
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ],
        feeScheduleId: 0,
        discountStrategyName: 'Click to select',
        isSaving: false,
        discountStrategyOptions: [
          { value: null, text: '100%' },
          { value: 'FirstFull50Remaining', text: '100% 50%' },
          { value: 'FirstFullSecondAt50ThenZero', text: '100% 50% 0%' },
          { value: 'Discount25EachToZero', text: '100% 50% 25% 0%' },
          { value: 'Discount25Each', text: '100% 50% 25%' },
          { value: 'All60', text: '60%' },
          { value: 'Discount25EachWithDouble25', text: '100% 50% 25% 25% 0%' },
          { value: 'FirstFull2At50ThenZero', text: '100% 50% 50% 0%' }
        ]
      }
    },

    watch: {
      editAllowableFeeScheduleCode (newValue) {
        if (newValue.organizationAllowableFeeScheduleCodeId) {
          this.allowableFeeScheduleCode = _.clone(newValue)
          this.allowableFeeScheduleCode.medicareMultiplier *= 100
        } else {
          this.allowableFeeScheduleCode = {
            organizationAllowableFeeScheduleId: this.allowableFeeScheduleId
          }
        }
      },
      allowableFeeScheduleId (newValue) {
        if (newValue) {
          this.feeScheduleId = _.clone(newValue)
        }
      }

    },
    computed: {
      title () {
        if (this.allowableFeeScheduleCode && this.allowableFeeScheduleCode.organizationAllowableFeeScheduleCodeId) {
          return 'Edit Code'
        }
        return 'Create Code'
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (!this.allowableFeeScheduleCode.code) {
          this.addErrorForField('code', 'You must enter a code')
        }

        if (this.allowableFeeScheduleCode.discountEligible === null) {
          this.addErrorForField('discountEligible', 'You must select an option')
        }

        return !this.hasErrors()
      },

      closeModal () {
        this.$emit('update:visible', false)
      },
      saveFeeScheduleCode () {
        if (!this.validate()) {
          return
        }
        if (this.isSaving === true) {
          return
        }
        const code = _.assign({}, this.allowableFeeScheduleCode)
        if (code.medicareMultiplier) {
          code.medicareMultiplier /= 100
        }
        this.isSaving = true
        api.post('Dashboard/AllowableFeeSchedules/' + this.allowableFeeScheduleId + '/Codes', code).then(response => {

          this.isSaving = false
          this.$emit('updated', response)
          this.allowableFeeScheduleCode = {}
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      }
    }

  }
</script>
